import { useState, useEffect, useCallback } from "react";
import {
  Organization,
  OrganizationService,
} from "@/shared/services/organization.service";
import { MESSAGES } from "../organizations.constants";

/**
 * Custom hook for fetching organizations data
 * @returns Object containing organizations data, loading state, error state, and refetch function
 */
export const useOrganizations = () => {
  const [organizations, setOrganizations] = useState<Organization[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchOrganizations = useCallback(async () => {
    try {
      setLoading(true);
      const data = await OrganizationService.getAll();
      setOrganizations(data);
      setError(null);
    } catch (err) {
      console.error("Failed to fetch organizations:", err);
      setError(MESSAGES.ERROR);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchOrganizations();
  }, [fetchOrganizations]);

  return { organizations, loading, error, refetch: fetchOrganizations };
};
